import { render, staticRenderFns } from "./ModalPisCofinsRefact.vue?vue&type=template&id=9788a854&scoped=true"
import script from "./ModalPisCofinsRefact.vue?vue&type=script&lang=js"
export * from "./ModalPisCofinsRefact.vue?vue&type=script&lang=js"
import style0 from "./ModalPisCofinsRefact.vue?vue&type=style&index=0&id=9788a854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9788a854",
  null
  
)

export default component.exports